import { pageLoaded, $ } from "venuescanner-js/tools/elemental";
import "venuescanner-scss/stylesheets/pages/_shortlist.scss";
import Cookies from "js-cookie";

pageLoaded(() => {
  const shortlist = document.querySelector("#shortlist-with-items");
  const shortlistEmpty = document.querySelector("#shortlist-without-items");
  const enquireCTA = document.querySelector("#shortlist-form-open");
  const selectAllCTA = document.querySelector("#shortlist-form-select-all");
  const activeSpaceTiles = [];
  document.querySelector("#shortlist-count-number").textContent =
    window.widgetsData.shortlist_items.length;
  window.addEventListener(
    "shortlistCountUpdate",
    (e) =>
      (document.querySelector("#shortlist-count-number").textContent =
        e.detail.count)
  );

  window.enquiryFormData.spaces.forEach((space) => {
    activeSpaceTiles.push(space.oid);
  });

  const updateSelectedCount = () => {
    const spaceTiles = document.querySelectorAll(".space-tile");
    const selectedItems = document.querySelectorAll(".space-tile.isSelected");

    const selectedItemsCount = selectedItems.length;

    if (!selectedItemsCount) {
      selectAllCTA.textContent = "Select all";
      enquireCTA.textContent = "Contact all venues";
    }

    if (selectedItemsCount > 0 && selectedItemsCount < spaceTiles.length) {
      selectAllCTA.classList.remove("isSelected");
      selectAllCTA.textContent = "Select all";
      enquireCTA.textContent = "Contact selected venues";
    }

    if (selectedItemsCount > 0 && selectedItemsCount === spaceTiles.length) {
      selectAllCTA.classList.add("isSelected");
      selectAllCTA.textContent = "Deselect all";

      enquireCTA.textContent =
        selectedItemsCount === 1
          ? "Contact selected venue"
          : "Contact all venues";
    }
  };

  $("[id^=space-tile-shortlist-select]").click(function () {
    const spaceTile = this.closest(".space-tile");
    const spaceOID = $(this).attr("data-oid");

    if (spaceTile.classList.contains("isSelected")) {
      const index = window.enquiryFormData.selectedSpaces.indexOf(spaceOID);
      if (index > -1) window.enquiryFormData.selectedSpaces.splice(index, 1);
      spaceTile.classList.remove("isSelected");
    } else {
      window.enquiryFormData.selectedSpaces.push(spaceOID);
      spaceTile.classList.add("isSelected");
    }
    updateSelectedCount();
  });

  $("#shortlist-form-select-all").click(function () {
    const spaceTiles = document.querySelectorAll(".space-tile");

    if (this.classList.contains("isSelected")) {
      this.classList.remove("isSelected");
      this.textContent = "Select all";
      window.enquiryFormData.selectedSpaces = [];
      spaceTiles.forEach((tile) => {
        tile.classList.remove("isSelected");
        setSpaceInputChecked(tile.dataset.oid, false);
      });
    } else {
      this.classList.add("isSelected");
      this.textContent = "Deselect all";
      window.enquiryFormData.selectedSpaces = [];
      spaceTiles.forEach((tile) => {
        tile.classList.add("isSelected");
        setSpaceInputChecked(tile.dataset.oid, true);
        window.enquiryFormData.selectedSpaces.push(tile.dataset.oid);
      });
    }
    updateSelectedCount();
  });

  $("[id^=space-tile-shortlist-delete]").click(function () {
    const index = activeSpaceTiles.indexOf($(this).attr("data-oid"));
    activeSpaceTiles.splice(index, 1);

    if (activeSpaceTiles.length <= 0) {
      shortlist.classList.add("hide");
      shortlistEmpty.classList.remove("hide");
    }

    if (activeSpaceTiles.length <= 3) {
      document.querySelector("#shortlist-recommend").classList.remove("hide");
      document
        .querySelector("#shortlist-items")
        .classList.add("shortlist__items--short");
    }

    const searchQueryCookie = Cookies.get("search_query");
    if (
      activeSpaceTiles.length > 0 &&
      activeSpaceTiles.length <= 3 &&
      !searchQueryCookie
    ) {
      const spaceLocation = document
        .querySelector(
          `.space-tile[data-oid="${
            activeSpaceTiles[activeSpaceTiles.length - 1]
          }"]`
        )
        .getAttribute("data-location");
      document
        .querySelector("#shortlist-recommend a")
        .setAttribute("href", `/search?location=${spaceLocation}`);
    }

    document
      .querySelector(`.space-tile[data-oid="${$(this).attr("data-oid")}"]`)
      .remove();
  });
});

function setSpaceInputChecked(oid, checked) {
  const input = document.getElementById(`space-tile-shortlist-select-${oid}`);
  input.checked = checked;
}
